export default "__VITE_PUBLIC_ASSET__517447ae__"